window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.response.use(null ,  (error) => {

    const response = error.response;

    if (response.status === 422)
    {
        toaster("Validation error." ,"danger");
    }
    else if (response.status === 429)
    {
        toaster(response.data.message  ,"danger");
    }
    else if (response.status === 404 || response.status === 500 || response.status === 400)
    {
        toaster(response.data.message + ". Please contact administration." , "danger");
    }

    if (response.status === 401 || response.status === 419)
    {
        toaster("Reloading page, User logged out or some error occur.","error");
        location.reload();
        return Promise.reject(error);
    }

    return Promise.reject(error);
});
